import en from "./en.json";
import cn from "./cn.json";

export const nextLocal = {
  en: { ...en },
  cn: { ...cn },
};